module.exports = __webpack_public_path__ + "img/bank-card-gold.4e89a06f.png";